import { render, staticRenderFns } from "./AlbumsList.vue?vue&type=template&id=257cdaee&scoped=true"
import script from "./AlbumsList.vue?vue&type=script&lang=ts"
export * from "./AlbumsList.vue?vue&type=script&lang=ts"
import style0 from "./AlbumsList.vue?vue&type=style&index=0&id=257cdaee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257cdaee",
  null
  
)

export default component.exports